(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    if (window.__uwCartInit) return;
    window.__uwCartInit = true;

    var DEBOUNCE_MS = 300;

    var pending = {};
    var confirmed = {};
    var armed = 0;
    var inflight = 0;
    var freshHtml = null;
    var freshKey = null;

    var queue = Promise.resolve();

    function cartRoot() { return document.querySelector('[data-uw-cart]'); }

    function say(li, message) {
      var node = li ? li.querySelector('[data-uw-cart-status]') : null;
      if (!node) return;
      node.textContent = message || '';
    }

    function paint(li, quantity) {
      var count = li.querySelector('[data-uw-qty-count]');
      if (count) count.textContent = quantity;
      li.setAttribute('data-uw-qty', quantity);
      var down = li.querySelector('[data-uw-qty-down]');
      if (!down) return;
      var label = quantity === 1 ? down.getAttribute('data-uw-label-remove')
                                 : down.getAttribute('data-uw-label-decrease');
      if (label) down.setAttribute('aria-label', label);
    }

    function paintHeaderCount(count) {
      var link = document.querySelector('[data-uw-cart-link]');
      if (!link) return;
      var sup = link.querySelector('[data-uw-cart-count]');
      if (!count) {
        if (sup) sup.parentNode.removeChild(sup);
        return;
      }
      if (!sup) {
        sup = document.createElement('sup');
        sup.setAttribute('data-uw-cart-count', '');
        link.insertBefore(sup, link.firstChild);
      }
      sup.textContent = count;
    }

    function applyFresh() {
      if (armed !== 0 || inflight !== 0 || !freshHtml) return;
      var live = document.querySelector('.uw-cart');
      if (!live || !live.parentNode) return;
      var parsed = new DOMParser().parseFromString(freshHtml, 'text/html');
      var next = parsed.querySelector('.uw-cart');
      var key = freshKey;
      freshHtml = null;
      freshKey = null;
      if (!next) return;
      var hadFocus = live.contains(document.activeElement);
      var oldNote = live.querySelector('[data-uw-cart-note]');
      var noteFocused = !!oldNote && document.activeElement === oldNote;
      live.parentNode.replaceChild(next, live);
      confirmed = {};
      var newNote = next.querySelector('[data-uw-cart-note]');
      if (oldNote && newNote) newNote.value = oldNote.value;
      if (!hadFocus) return;
      if (noteFocused && newNote) {
        newNote.focus();
        newNote.setSelectionRange(oldNote.selectionStart, oldNote.selectionEnd);
        return;
      }
      var target = document.querySelector('[data-uw-line="' + key + '"] [data-uw-qty-down]')
        || document.querySelector('[data-uw-cart] [data-uw-qty-down]')
        || document.querySelector('[name="checkout"]');
      if (target && target.focus) target.focus();
    }

    function revert(li, key) {
      if (!li || !(key in confirmed)) return;
      li.classList.remove('is-busy');
      paint(li, confirmed[key]);
    }

    function send(key, quantity, li) {
      var root = cartRoot();
      if (!root) return;
      var d = root.dataset;
      inflight++;
      return fetch(d.uwCartChangeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: d.uwCartSection })
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (r) {
          if (!r.ok) {
            revert(li, key);
            say(li, (r.data && r.data.description) || d.uwLabelError);
            return;
          }
          confirmed[key] = quantity;
          paintHeaderCount(r.data.item_count);
          if (r.data.sections && r.data.sections[d.uwCartSection]) {
            freshHtml = r.data.sections[d.uwCartSection];
            freshKey = key;
          }
        })
        .catch(function () {
          revert(li, key);
          say(li, d.uwLabelError);
        })
        .then(function () {
          inflight--;
          applyFresh();
        });
    }

    function fire(key) {
      var entry = pending[key];
      if (!entry) return;
      if (entry.timer) { clearTimeout(entry.timer); armed--; }
      delete pending[key];
      var quantity = entry.desired;
      var li = entry.li;
      queue = queue.then(function () { return send(key, quantity, li); });
    }

    function step(li, delta) {
      var key = li.getAttribute('data-uw-line');
      if (!key) return;
      if (!(key in confirmed)) {
        confirmed[key] = parseInt(li.getAttribute('data-uw-qty'), 10) || 0;
      }
      var entry = pending[key];
      var current = entry ? entry.desired : confirmed[key];
      var next = current + delta;
      if (next < 0) return;

      say(li, '');
      if (!entry) {
        entry = pending[key] = { desired: next, timer: null, li: li };
      } else {
        entry.desired = next;
      }

      if (next === 0) {
        li.classList.add('is-busy');
        fire(key);
        return;
      }

      paint(li, next);
      if (entry.timer) clearTimeout(entry.timer);
      else armed++;
      entry.timer = setTimeout(function () { fire(key); }, DEBOUNCE_MS);
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      var button = event.target.closest('[data-uw-qty-up], [data-uw-qty-down]');
      if (!button) return;
      var li = button.closest('[data-uw-line]');
      if (!li) return;
      event.preventDefault();
      step(li, button.hasAttribute('data-uw-qty-up') ? 1 : -1);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    if (window.__uwNavInit) return;
    window.__uwNavInit = true;

    var drawer = null;
    var lastTrigger = null;

    function openDrawer(trigger) {
      drawer = document.querySelector('[data-uw-nav]');
      if (!drawer) return;
      lastTrigger = trigger || null;
      drawer.hidden = false;
      document.documentElement.classList.add('uw-nav-open');
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      var closeBtn = drawer.querySelector('.uw-nav__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      if (!drawer || drawer.hidden) return;
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('uw-nav-open');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var el = drawer;
      if (reduce) el.hidden = true;
      else setTimeout(function () { el.hidden = true; }, 240);
      if (lastTrigger) {
        lastTrigger.setAttribute('aria-expanded', 'false');
        if (typeof lastTrigger.focus === 'function') lastTrigger.focus();
      }
      lastTrigger = null;
    }

    window.uwCloseNavDrawer = closeDrawer;

    function trapTab(e) {
      if (!drawer || drawer.hidden) return;
      var f = drawer.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-uw-nav-open]');
      if (trigger) { e.preventDefault(); openDrawer(trigger); return; }
      if (e.target.closest('[data-uw-nav-close]')) closeDrawer();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key === 'Tab') trapTab(e);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (function () {
    if (window.__uwPwGateInit) return;
    window.__uwPwGateInit = true;

    var toggle = document.querySelector('[data-uw-pw-toggle]');
    var region = document.getElementById('uw-pw-gate');
    if (!toggle || !region) return;

    var input = region.querySelector('#password-input');

    function setExpanded(open, moveFocus) {
      region.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!moveFocus) return;
      if (open) {
        if (input && typeof input.focus === 'function') input.focus();
      } else if (typeof toggle.focus === 'function') {
        toggle.focus();
      }
    }

    toggle.hidden = false;

    if (!region.hasAttribute('data-uw-pw-open')) setExpanded(false, false);

    toggle.addEventListener('click', function () {
      setExpanded(toggle.getAttribute('aria-expanded') !== 'true', true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uncomfy-desk"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__uwDeskTvInit) return;
    window.__uwDeskTvInit = true;

    var modal = null;
    var videoWrap = null;
    var lastTrigger = null;

    function buildEmbed(raw) {
      var url = (raw || '').trim();
      if (!url) return null;
      var base = 'https://www.youtube-nocookie.com/embed/';
      var params = 'autoplay=1&rel=0&modestbranding=1&playsinline=1';
      var listMatch = url.match(/[?&]list=([\w-]+)/i);
      var list = listMatch ? listMatch[1] : null;
      var id = null;
      var m;

      if ((m = url.match(/youtube(?:-nocookie)?\.com\/embed\/([\w-]+)/i))) id = m[1];
      else if ((m = url.match(/youtu\.be\/([\w-]+)/i))) id = m[1];
      else if ((m = url.match(/[?&]v=([\w-]+)/i))) id = m[1];

      if (id) return base + id + '?' + params + (list ? '&list=' + list : '');
      if (list) return base + 'videoseries?' + params + '&list=' + list;
      if ((m = url.match(/\/channel\/(UC[\w-]+)/i))) {
        return base + 'videoseries?' + params + '&list=UU' + m[1].slice(2);
      }
      return null;
    }

    function openModal(rawUrl, trigger) {
      modal = document.querySelector('[data-uw-tv]');
      if (!modal) return;
      videoWrap = modal.querySelector('[data-uw-tv-video]');
      lastTrigger = trigger || null;
      videoWrap.textContent = '';

      var src = buildEmbed(rawUrl);
      if (src) {
        var iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.title = 'YouTube video player';
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        iframe.setAttribute('allowfullscreen', '');
        videoWrap.appendChild(iframe);
      } else {
        var note = document.createElement('p');
        note.className = 'uw-tv__note';
        note.textContent = 'Add a YouTube video, playlist, or channel-ID URL.';
        videoWrap.appendChild(note);
      }

      modal.hidden = false;
      document.documentElement.classList.add('uw-tv-open');
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      var closeBtn = modal.querySelector('.uw-tv__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      if (!modal || modal.hidden) return;
      modal.classList.remove('is-open');
      if (videoWrap) videoWrap.textContent = '';
      document.documentElement.classList.remove('uw-tv-open');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var el = modal;
      if (reduce) el.hidden = true;
      else setTimeout(function () { el.hidden = true; }, 200);
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
      lastTrigger = null;
    }

    function trapTab(e) {
      if (!modal || modal.hidden) return;
      var f = modal.querySelectorAll('button, iframe, a[href], [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-uw-video]');
      if (trigger) {
        e.preventDefault();
        openModal(trigger.getAttribute('data-uw-video'), trigger);
        return;
      }
      if (e.target.closest('[data-uw-tv-close]')) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key === 'Tab') trapTab(e);
    });
  })();

  (function () {
    if (!('IntersectionObserver' in window)) return;
    if (window.__uwDeskRevealInit) return;
    window.__uwDeskRevealInit = true;

    function observe(root) {
      var scopes = (root || document).querySelectorAll('.uw-desk');
      Array.prototype.forEach.call(scopes, observeDesk);
    }

    function observeDesk(desk) {
      var items = desk.querySelectorAll('.uw-desk__item');
      if (!items.length) return;

      var trigger = parseFloat(desk.getAttribute('data-uw-reveal-trigger'));
      if (isNaN(trigger)) trigger = 40;
      var stagger = parseFloat(desk.getAttribute('data-uw-reveal-stagger'));
      if (isNaN(stagger)) stagger = 0;

      var boxH = window.innerHeight * (1 - trigger / 100);
      var tallest = 0;
      Array.prototype.forEach.call(items, function (el) {
        if (el.offsetHeight > tallest) tallest = el.offsetHeight;
      });
      var threshold = 0.6;
      if (tallest > 0) threshold = Math.min(0.6, (boxH * 0.85) / tallest);

      var io = new IntersectionObserver(function (entries) {
        var arriving = [];
        entries.forEach(function (entry) {
          if (entry.isIntersecting) arriving.push(entry);
        });
        arriving.sort(function (a, b) {
          return (a.boundingClientRect.top - b.boundingClientRect.top) ||
                 (a.boundingClientRect.left - b.boundingClientRect.left);
        });
        arriving.forEach(function (entry, i) {
          var el = entry.target;
          if (stagger > 0 && i > 0) el.style.setProperty('--uw-reveal-delay', (i * stagger) + 'ms');
          el.classList.add('is-revealed');
          io.unobserve(el);
        });
      }, { threshold: threshold, rootMargin: '0px 0px ' + -trigger + '% 0px' });

      Array.prototype.forEach.call(items, function (el) {
        if (el.querySelector('.uw-desk__img--hover')) io.observe(el);
      });
    }

    var MIN_SCROLL = 24;
    var startY = window.pageYOffset;
    var hasScrolled = false;
    var pending = [];

    function run(root) {
      if (hasScrolled) observe(root);
      else pending.push(root);
    }

    function onScroll() {
      if (Math.abs(window.pageYOffset - startY) < MIN_SCROLL) return;
      hasScrolled = true;
      window.removeEventListener('scroll', onScroll);
      pending.forEach(observe);
      pending = [];
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    run(document);
    document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uncomfy-guestbook"]) return;
  try {
    
  (function () {
    var DELIM = '::uwcfg::';
    var KEYS = ['uwv', 'f', 'c', 'a', 'r', 'n'];
    function isKey(key) {
      return KEYS.indexOf(key) !== -1 || /^q\d+$/.test(key);
    }
    var MAX = 2000;

    var body = document.querySelector('[data-uw-gb-body]');
    if (!body) return;
    var form = body.form || body.closest('form');
    if (!form) return;

    function encodeAtom(value) {
      return String(value == null ? '' : value)
        .replace(/%/g, '%25')
        .replace(/\|/g, '%7C')
        .replace(/=/g, '%3D')
        .replace(/,/g, '%2C')
        .replace(/:/g, '%3A')
        .replace(/\r/g, '%0D')
        .replace(/\n/g, '%0A');
    }

    function recodeValue(value) {
      return value.split(/([,:])/).map(function (part) {
        if (part === ',' || part === ':') return part;
        var decoded;
        try {
          decoded = decodeURIComponent(part);
        } catch (err) {
          decoded = part;
        }
        return encodeAtom(decoded);
      }).join('');
    }

    function fromQuery() {
      var search = window.location.search.replace(/^\?/, '');
      if (!search) return '';
      var out = [];
      search.split('&').forEach(function (pair) {
        var eq = pair.indexOf('=');
        if (eq < 1) return;
        var key = pair.slice(0, eq);
        if (!isKey(key)) return;
        out.push(key + '=' + recodeValue(pair.slice(eq + 1)));
      });
      if (!out.length) return '';
      var joined = out.join('|');
      if (joined.indexOf('uwv=') !== 0) return '';
      return joined.length > MAX ? '' : joined;
    }

    function reclaimFromTextarea() {
      var value = body.value;
      var at = value.lastIndexOf(DELIM);
      if (at === -1) return '';
      var tail = value.slice(at + DELIM.length).replace(/^\s+/, '');
      if (!/^uwv=\d/.test(tail)) return '';
      body.value = value.slice(0, at).replace(/\s+$/, '');
      return tail.length > MAX ? '' : tail;
    }

    var config = reclaimFromTextarea() || fromQuery();

    if (config) {
      var signing = document.querySelector('.uw-gb__signing');
      if (signing) signing.hidden = false;
    }

    function answerPairs() {
      var pairs = [];
      document.querySelectorAll('[data-uw-gb-question]').forEach(function (sel) {
        var value = sel.value;
        if (!value) return;
        if (!/^a\d+$/.test(value)) return;
        var slot = sel.getAttribute('data-uw-gb-question');
        if (!/^\d+$/.test(slot)) return;
        pairs.push('q' + slot + '=' + encodeAtom(value));
      });
      return pairs;
    }

    var payload = form.querySelector('[data-uw-gb-payload]');
    var submitBtn = form.querySelector('[type="submit"]');
    var submitting = false;

    function withoutAnswers(value) {
      return value.split('|').filter(function (pair) {
        return !/^q\d+=/.test(pair);
      }).join('|');
    }

    form.addEventListener('submit', function (event) {
      // The flag is the real guard — it also catches Enter. The disabled
      // button is feedback only.
      if (submitting) {
        event.preventDefault();
        return;
      }
      submitting = true;
      if (submitBtn) submitBtn.disabled = true;

      // Built fresh from the original config on every submit and never
      // written back, so a repeat submit cannot append the answers twice.
      var outgoing = config;
      var answers = answerPairs();
      if (answers.length) {
        var base = config ? withoutAnswers(config) : 'uwv=1';
        var merged = base + '|' + answers.join('|');
        if (merged.length <= MAX) outgoing = merged;
      }
      if (!outgoing || !payload) return;

      var words = body.value.replace(/\s+$/, '');
      if (words.indexOf(DELIM) !== -1) return;

      payload.value = words + '\n' + DELIM + ' ' + outgoing;
      payload.setAttribute('name', 'comment[body]');
      body.removeAttribute('name');
    });

    // Back into a bfcached page restores the frozen post-submit state: flag
    // set, button disabled, textarea unnamed. Undo all of it or the form is dead.
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      submitting = false;
      if (submitBtn) submitBtn.disabled = false;
      body.setAttribute('name', 'comment[body]');
      if (payload) {
        payload.removeAttribute('name');
        payload.value = '';
      }
    });
  })();

  (function () {
    var root = document.querySelector('.uw-gb');
    if (!root) return;

    var ART_W = 320;

    var UW_GB_POLAROID = {
      windowCenterX: 49.46,
      windowCenterY: 43.56,
      windowWidth: 73.08,
      windowHeight: 72.88,
      windowRotation: 0,
      captionLeft: 12.92,
      captionTop: 80.00,
      captionWidth: 73.08,
      captionHeight: 15.50,
      captionRotation: 0
    };

    var UW_GB_WINDOW_BLEED = 2.5;

    // Lookup key only — never displayed. A recipe link that has been through a
    // form-urlencoded hop (share sheet, mail rewriter, redirect) arrives with
    // every space turned into a plus, and that corruption is stored permanently.
    // Folding plus back to a space here lets those entries still match the
    // catalog. It is not done at parse time, where it would corrupt a name
    // someone genuinely typed with a plus in it.
    function norm(value) {
      return String(value == null ? '' : value)
        .replace(/[‐-―−]/g, '-')
        .replace(/-+/g, '-')
        .replace(/\+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    function decode(value) {
      try {
        return decodeURIComponent(value);
      } catch (err) {
        return value;
      }
    }

    var QUESTIONS = (function () {
      var node = root.querySelector('[data-uw-gb-questions]');
      if (!node) return [];
      try {
        var parsed = JSON.parse(node.textContent);
        return Array.isArray(parsed) ? parsed : [];
      } catch (err) {
        return [];
      }
    })();

    function answerLines(cfg) {
      var lines = [];
      QUESTIONS.forEach(function (q) {
        var given = cfg.q[String(q.i)];
        if (!given) return;
        var text = (q.options || {})[given];
        if (text) lines.push({ label: q.label, value: String(text) });
      });
      return lines;
    }

    function parseConfig(raw) {
      var out = { f: '', c: '', a: [], r: [], n: '', q: {} };
      String(raw).split('|').forEach(function (pair) {
        var eq = pair.indexOf('=');
        if (eq < 1) return;
        var key = pair.slice(0, eq);
        var value = pair.slice(eq + 1);
        if (key === 'f' || key === 'c' || key === 'n') {
          out[key] = decode(value);
        } else if (key === 'a') {
          out.a = value.split(',').map(decode).filter(Boolean);
        } else if (/^q\d+$/.test(key)) {
          out.q[key.slice(1)] = decode(value);
        } else if (key === 'r') {
          out.r = value.split(',').map(function (p) { return p.split(':').map(decode); });
        }
      });
      return out;
    }

    var catalogPromise = null;

    function loadCatalog() {
      if (catalogPromise) return catalogPromise;
      var src = root.getAttribute('data-uw-gb-catalog-src');
      if (!src) return (catalogPromise = Promise.reject(new Error('no catalog source')));
      catalogPromise = fetch(src, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('catalog ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var out = {};
          doc.querySelectorAll('script[type="application/json"][data-uncomfy-catalog]')
            .forEach(function (node) {
              var name = node.getAttribute('data-uncomfy-catalog');
              if (!name) return;
              try {
                var parsed = JSON.parse(node.textContent);
                if (Array.isArray(parsed)) out[name] = parsed;
              } catch (err) {  }
            });
          if (!out.friends || !out.fur || !out.accessories) {
            throw new Error('catalog incomplete');
          }
          var stage = doc.querySelector('[data-uw-room-stage]');
          var baseImg = stage ? stage.querySelector('img.uw-room__base') : null;
          return {
            friends: index(out.friends, 'name'),
            fur: out.fur,
            accessories: index(out.accessories, 'name'),
            room: index(out.room || [], 'name'),
            roomCategories: out.room_categories || [],
            base: baseImg ? baseImg.getAttribute('src') : '',
            floorOverlay: stage ? stage.getAttribute('data-uw-room-floor-overlay') : '',
            charScale: stage ? stage.style.getPropertyValue('--uw-room-char-scale').trim() : '',
            charFloor: stage ? stage.style.getPropertyValue('--uw-room-char-floor').trim() : ''
          };
        });
      return catalogPromise;
    }

    function index(list, key) {
      var map = new Map();
      list.forEach(function (item) {
        if (item && item[key]) map.set(norm(item[key]), item);
      });
      return map;
    }

    var REGION_DRAW_ORDER = {
      back: 0, feet: 1, torso: 2, hand: 3, neck: 4, ears: 5, crown: 6, head_top: 7, face: 8
    };

    function regionPriority(acc) {
      var regs = acc && acc.regions ? acc.regions : [];
      var p = 0;
      for (var i = 0; i < regs.length; i++) {
        var v = REGION_DRAW_ORDER[regs[i]];
        if (v > p) p = v;
      }
      return p;
    }

    function uwGbLayers(fur, accs) {
      if (!fur) return [];
      var useEars = accs.some(function (a) { return a.triggers_ears_apart; }) && !!fur.body_ears;
      var bodyUrl = useEars ? fur.body_ears : fur.body;
      if (!bodyUrl) return [];
      var layers = [{ url: bodyUrl, label: fur.fur }];
      accs.slice()
        .sort(function (a, b) {
          var dz = Number(a.z) - Number(b.z);
          if (dz !== 0) return dz;
          return regionPriority(a) - regionPriority(b);
        })
        .forEach(function (a) {
          if (a.layer) layers.push({ url: a.layer, label: a.name });
        });
      return layers;
    }

    var ROOM_FLOOR_OVERLAY_Z = 1.5;
    var ROOM_FLOOR_Z = 2;

    function categoryZ(cats, name) {
      for (var i = 0; i < cats.length; i++) {
        if (cats[i].name === name) return Number(cats[i].z);
      }
      return 0;
    }

    function uwGbRoomLayers(picks, catalog) {
      var layers = [];
      picks.forEach(function (pick) {
        if (!pick || !pick.layer) return;
        layers.push({ url: pick.layer, z: categoryZ(catalog.roomCategories, pick.category) });
      });
      var hasPickedFloor = layers.some(function (l) { return l.z === ROOM_FLOOR_Z; });
      if (!hasPickedFloor && catalog.floorOverlay) {
        layers.push({ url: catalog.floorOverlay, z: ROOM_FLOOR_OVERLAY_Z });
      }
      return layers.sort(function (a, b) { return a.z - b.z; });
    }

    function sized(url) {
      return String(url).replace(/([?&]width=)\d+/, '$1' + ART_W);
    }

    function resolve(cfg, catalog) {
      var friend = cfg.f ? catalog.friends.get(norm(cfg.f)) : null;
      if (!friend) return null;

      var wantFur = norm(cfg.c);
      var wantFriend = norm(cfg.f);
      var fur = null;
      for (var i = 0; i < catalog.fur.length; i++) {
        var f = catalog.fur[i];
        if (norm(f.fur) === wantFur && norm(f.friend) === wantFriend) { fur = f; break; }
      }
      if (!fur) return null;

      // Accessories and room items degrade: an entry is a permanent record and
      // the catalog moves under it, so a reworded or retired item must not take
      // the whole scene down with it. Friend and fur above stay hard failures —
      // there is no character to draw without them.
      var accs = [];
      for (var j = 0; j < cfg.a.length; j++) {
        var acc = catalog.accessories.get(norm(cfg.a[j]));
        if (!acc) continue;
        accs.push(acc);
      }

      var picks = [];
      for (var k = 0; k < cfg.r.length; k++) {
        var wanted = cfg.r[k][1];
        if (!wanted) continue;
        var item = catalog.room.get(norm(wanted));
        if (!item) continue;
        picks.push(item);
      }

      var charLayers = uwGbLayers(fur, accs);
      if (!charLayers.length) return null;

      return {
        room: uwGbRoomLayers(picks, catalog),
        character: charLayers,
        base: catalog.base,
        charScale: catalog.charScale,
        charFloor: catalog.charFloor,
        name: cfg.n || ''
      };
    }

    function makeLayer(url) {
      var img = document.createElement('img');
      img.className = 'uw-gb__layer';
      img.src = sized(url);
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = ART_W;
      img.height = Math.round(ART_W * 4 / 3);
      img.alt = '';
      return img;
    }

    function paintAnswers(entry, lines, name) {
      if (!lines.length) return;
      var box = entry.querySelector('[data-uw-gb-answers]');
      if (!box) return;
      var group = entry.querySelector('[data-uw-gb-about]');
      var title = entry.querySelector('[data-uw-gb-about-title]');
      if (title) title.textContent = name ? 'more about ' + name + '!' : 'more about this friend!';
      lines.forEach(function (line) {
        var p = document.createElement('p');
        p.className = 'uw-gb__answer';
        var label = document.createElement('span');
        label.className = 'uw-gb__answer-label';
        label.textContent = line.label + ': ';
        p.appendChild(label);
        p.appendChild(document.createTextNode(line.value));
        box.appendChild(p);
      });
      if (group) group.hidden = false;
    }

    function paint(figure, resolved) {
      var stage = figure.querySelector('[data-uw-gb-stage]');
      if (!stage) return;

      if (resolved.charScale) stage.style.setProperty('--uw-room-char-scale', resolved.charScale);
      if (resolved.charFloor) stage.style.setProperty('--uw-room-char-floor', resolved.charFloor);

      if (resolved.base) stage.appendChild(makeLayer(resolved.base));
      resolved.room.forEach(function (l) { stage.appendChild(makeLayer(l.url)); });

      var charBox = document.createElement('div');
      charBox.className = 'uw-gb__character';
      resolved.character.forEach(function (l) { charBox.appendChild(makeLayer(l.url)); });
      stage.appendChild(charBox);

      if (figure.classList.contains('uw-gb__scene--framed')) {
        var P = UW_GB_POLAROID;
        var bleedW = UW_GB_WINDOW_BLEED;
        var bleedH = UW_GB_WINDOW_BLEED * 3 / 4;
        stage.style.setProperty('--uw-gb-win-cx', P.windowCenterX + '%');
        stage.style.setProperty('--uw-gb-win-cy', P.windowCenterY + '%');
        stage.style.setProperty('--uw-gb-win-w', (P.windowWidth + bleedW * 2) + '%');
        stage.style.setProperty('--uw-gb-win-h', (P.windowHeight + bleedH * 2) + '%');
        stage.style.setProperty('--uw-gb-win-rotate', P.windowRotation + 'deg');
        var cap = figure.querySelector('[data-uw-gb-caption]');
        if (cap) {
          cap.style.setProperty('--uw-gb-cap-left', P.captionLeft + '%');
          cap.style.setProperty('--uw-gb-cap-top', P.captionTop + '%');
          cap.style.setProperty('--uw-gb-cap-width', P.captionWidth + '%');
          cap.style.setProperty('--uw-gb-cap-height', P.captionHeight + '%');
          cap.style.setProperty('--uw-gb-cap-rotate', P.captionRotation + 'deg');
        }
      }

      if (resolved.name) {
        var captionText = figure.querySelector('[data-uw-gb-caption]');
        if (captionText) {
          captionText.textContent = resolved.name;
          captionText.style.setProperty('--uw-caption-chars', Math.max(resolved.name.length, 1));
          var captionBox = captionText.closest('.uw-gb__caption');
          if (captionBox) captionBox.hidden = false;
        }
      }

      stage.removeAttribute('aria-hidden');
    }

    var pending = [];
    root.querySelectorAll('[data-uw-config]').forEach(function (entry) {
      var frame = entry.querySelector('[data-uw-gb-art]');
      if (frame) pending.push({ entry: entry, frame: frame });
    });

    if (!pending.length) return;

    function collapseAll() {
      pending.forEach(function (item) { item.frame.remove(); });
    }

    loadCatalog().then(function (catalog) {
      pending.forEach(function (item) {
        var cfg = null, resolved = null;
        try {
          cfg = parseConfig(item.entry.getAttribute('data-uw-config'));
          resolved = resolve(cfg, catalog);
        } catch (err) {
          resolved = null;
        }
        if (cfg) paintAnswers(item.entry, answerLines(cfg), cfg.n);
        if (resolved) paint(item.frame, resolved);
        else item.frame.remove();
      });
    }).catch(function () {
      pending.forEach(function (item) {
        try {
          var c = parseConfig(item.entry.getAttribute('data-uw-config'));
          paintAnswers(item.entry, answerLines(c), c.n);
        } catch (err) {  }
      });
      collapseAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uw-announcement-bar"]) return;
  try {
    
  (function () {
    if (window.__uwAnnouncementInit) return;
    window.__uwAnnouncementInit = true;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

    function build(bar) {
      var viewport = bar.querySelector('.uw-announcement__viewport');
      var track = bar.querySelector('.uw-announcement__track');
      if (!viewport || !track) return;

      if (!track.__uwSeed) {
        var first = track.querySelector('.uw-announcement__item');
        if (!first) return;
        track.__uwSeed = first.cloneNode(true);
      }

      var reduced = reduce && reduce.matches;
      var width = viewport.clientWidth;

      if (reduced || !width) {
        bar.classList.remove('is-marquee');
        track.innerHTML = '';
        track.appendChild(track.__uwSeed.cloneNode(true));
        return;
      }

      bar.classList.add('is-marquee');
      track.innerHTML = '';
      var probe = track.__uwSeed.cloneNode(true);
      track.appendChild(probe);
      var itemWidth = probe.getBoundingClientRect().width;

      if (!itemWidth) {
        bar.classList.remove('is-marquee');
        return;
      }

      var once = bar.getAttribute('data-uw-repeat') === 'once';
      var copies = once ? 1 : Math.ceil(width / itemWidth) + 1;
      var groupWidth = once ? itemWidth + width : copies * itemWidth;

      track.innerHTML = '';
      var frag = document.createDocumentFragment();
      for (var g = 0; g < 2; g++) {
        for (var i = 0; i < copies; i++) {
          frag.appendChild(track.__uwSeed.cloneNode(true));
        }
        if (once) {
          var gap = document.createElement('span');
          gap.className = 'uw-announcement__gap';
          frag.appendChild(gap);
        }
      }
      track.appendChild(frag);

      var items = track.querySelectorAll('.uw-announcement__item');
      for (var n = 1; n < items.length; n++) {
        items[n].setAttribute('aria-hidden', 'true');
      }

      var speed = parseFloat(bar.getAttribute('data-uw-speed'));
      if (!speed || speed < 1) speed = 25;
      bar.style.setProperty('--uw-marquee-gap', width + 'px');
      bar.style.setProperty('--uw-marquee-duration', (groupWidth / speed).toFixed(2) + 's');
      track.__uwWidth = width;
    }

    function bind(bar) {
      if (bar.__uwBound) return;
      bar.__uwBound = true;
      build(bar);

      if (window.ResizeObserver) {
        var vp = bar.querySelector('.uw-announcement__viewport');
        if (vp) {
          new ResizeObserver(function () {
            var track = bar.querySelector('.uw-announcement__track');
            if (track && track.__uwWidth === vp.clientWidth) return;
            build(bar);
          }).observe(vp);
        }
      }
    }

    function run() {
      var found = document.querySelectorAll('[data-uw-announcement]');
      Array.prototype.forEach.call(found, bind);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          Array.prototype.forEach.call(found, build);
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
    if (reduce && reduce.addEventListener) {
      reduce.addEventListener('change', function () {
        Array.prototype.forEach.call(document.querySelectorAll('[data-uw-announcement]'), build);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uw-image-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__uwImageTextSwapInit) return;
    window.__uwImageTextSwapInit = true;

    var hover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
    if (hover && hover.matches) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduce && reduce.matches) return;
    if (!window.IntersectionObserver) return;

    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var media = entries[i].target.__uwSwapMedia;
        if (media) media.classList.toggle('is-swapped', entries[i].isIntersecting);
      }
    }, { rootMargin: '-25% 0px -25% 0px' });

    function bind(media) {
      if (media.__uwSwapBound) return;
      media.__uwSwapBound = true;
      var row = media.parentNode;
      if (!row) return;
      var target = row.querySelector('.uw-image-text__body') || row;
      target.__uwSwapMedia = media;
      observer.observe(target);
    }

    function run() {
      var found = document.querySelectorAll('.uw-image-text__media--swap');
      Array.prototype.forEach.call(found, bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uw-newsletter-popup"]) return;
  try {
    
  (function () {
    if (window.__uwNewsletterInit) return;
    window.__uwNewsletterInit = true;

    var dialog = null;
    var lastTrigger = null;

    function openDialog(trigger) {
      dialog = document.querySelector('[data-uw-nl]');
      if (!dialog) return;

      if (typeof window.uwCloseNavDrawer === 'function') window.uwCloseNavDrawer();

      lastTrigger = trigger || null;
      dialog.hidden = false;
      document.documentElement.classList.add('uw-nl-open');
      requestAnimationFrame(function () { dialog.classList.add('is-open'); });

      var closeBtn = dialog.querySelector('.uw-nl__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeDialog() {
      if (!dialog || dialog.hidden) return;
      dialog.classList.remove('is-open');
      document.documentElement.classList.remove('uw-nl-open');

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var el = dialog;
      if (reduce) el.hidden = true;
      else setTimeout(function () { el.hidden = true; }, 200);

      returnFocus();
    }

    function returnFocus() {
      var el = lastTrigger;
      if (!el || !el.isConnected || el.offsetParent === null) {
        el = document.querySelector('[data-uw-nav-open]');
      }
      if (el && typeof el.focus === 'function') el.focus();
      lastTrigger = null;
    }

    function trapTab(e) {
      if (!dialog || dialog.hidden) return;
      var f = dialog.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-uw-nl-close]')) { closeDialog(); return; }

      var link = e.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (href === '#newsletter' || href.slice(-11) === '#newsletter') {
        e.preventDefault();
        openDialog(link);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDialog(); return; }
      if (e.key === 'Tab') trapTab(e);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uw-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__uwProductsInit) return;
    window.__uwProductsInit = true;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function sync(track) {
      var viewport = track.parentNode;
      if (!viewport) return;
      var overflow = track.scrollWidth - track.clientWidth;
      viewport.classList.toggle('is-scrollable', overflow > 1);
      var prev = viewport.querySelector('[data-uw-products-prev]');
      var next = viewport.querySelector('[data-uw-products-next]');
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= overflow - 1;
    }

    function pitchOf(track) {
      var items = track.children;
      if (items.length < 2) return track.clientWidth;
      return Math.abs(
        items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left
      );
    }

    function bind(track) {
      if (track.__uwProductsBound) return;
      track.__uwProductsBound = true;
      track.addEventListener('scroll', function () { sync(track); }, { passive: true });
      if (window.ResizeObserver) {
        new ResizeObserver(function () { sync(track); }).observe(track);
      }
      sync(track);
    }

    function run() {
      var found = document.querySelectorAll('[data-uw-products-track]');
      Array.prototype.forEach.call(found, bind);
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      var button = event.target.closest('[data-uw-products-prev], [data-uw-products-next]');
      if (!button) return;
      var viewport = button.closest('.uw-products__viewport');
      var track = viewport ? viewport.querySelector('[data-uw-products-track]') : null;
      if (!track) return;
      var direction = button.hasAttribute('data-uw-products-prev') ? -1 : 1;
      var pitch = pitchOf(track);
      var perView = Math.max(1, Math.round(track.clientWidth / pitch));
      track.scrollBy({
        left: direction * perView * pitch,
        behavior: reduce.matches ? 'auto' : 'smooth'
      });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();
})();
